export default "__VITE_ASSET__61b6da10__"